import Spinner from 'erxes-ui/lib/components/Spinner';

export default Spinner;
